import React from "react";
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Field from "../shared/Field";

const FormPricing = ({ draft, setDraft }) => {
  const updateFeature = (fi, value) => {
    const features = [...draft.features];
    features[fi] = value;
    setDraft((p) => ({ ...p, features }));
  };

  const addFeature = () =>
    setDraft((p) => ({ ...p, features: [...p.features, ""] }));

  const removeFeature = (fi) =>
    setDraft((p) => ({
      ...p,
      features: p.features.filter((_, idx) => idx !== fi),
    }));

  return (
    <Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <Field
          label="Package Name"
          value={draft.name}
          onChange={(v) => setDraft((p) => ({ ...p, name: v }))}
          placeholder="MVP Development"
        />
        <Field
          label="Badge (optional)"
          value={draft.badge}
          onChange={(v) => setDraft((p) => ({ ...p, badge: v }))}
          placeholder="MOST POPULAR"
        />
      </Box>
      <Box display="grid" gridTemplateColumns="1fr 1fr 1fr" gap={2}>
        <Field
          label="Price"
          value={draft.price}
          onChange={(v) => setDraft((p) => ({ ...p, price: v }))}
          placeholder="From $3,000"
        />
        <Box mb={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Price Type</InputLabel>
            <Select
              value={draft.priceType}
              label="Price Type"
              onChange={(e) =>
                setDraft((p) => ({ ...p, priceType: e.target.value }))
              }
              sx={{ borderRadius: "8px" }}
            >
              <MenuItem value="fixed">Fixed</MenuItem>
              <MenuItem value="custom">Custom Quote</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box mb={2}>
          <FormControl fullWidth size="small">
            <InputLabel>Highlighted?</InputLabel>
            <Select
              value={draft.highlighted}
              label="Highlighted?"
              onChange={(e) =>
                setDraft((p) => ({ ...p, highlighted: e.target.value }))
              }
              sx={{ borderRadius: "8px" }}
            >
              <MenuItem value={false}>No</MenuItem>
              <MenuItem value={true}>Yes</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Field
        label="Short Description (optional)"
        value={draft.description}
        onChange={(v) => setDraft((p) => ({ ...p, description: v }))}
        placeholder="Perfect for small businesses and landing pages"
      />
      
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
        <Field
          label="CTA Button Text"
          value={draft.ctaText}
          onChange={(v) => setDraft((p) => ({ ...p, ctaText: v }))}
          placeholder="Get Started"
        />
        <Field
          label="CTA URL"
          value={draft.ctaUrl}
          onChange={(v) => setDraft((p) => ({ ...p, ctaUrl: v }))}
          placeholder="/contact"
        />
      </Box>
      <Typography
        variant="caption"
        color="text.secondary"
        fontWeight={600}
        display="block"
        mb={1}
      >
        Features
      </Typography>
      {draft.features.map((feat, fi) => (
        <Box key={fi} display="flex" gap={1} mb={1} alignItems="center">
          <TextField
            fullWidth
            size="small"
            value={feat}
            onChange={(e) => updateFeature(fi, e.target.value)}
            placeholder={`Feature ${fi + 1}`}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <IconButton
            size="small"
            color="error"
            onClick={() => removeFeature(fi)}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={addFeature}
        sx={{ textTransform: "none", color: "text.secondary", mt: 0.5 }}
      >
        Add Feature
      </Button>
    </Box>
  );
};

export default FormPricing;
